import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IUploadFile } from '../../models';

import { ThankYouComponent } from '../thank-you/thank-you.component';
import { ToastrService } from 'ngx-toastr';
import { UploadService } from '../../services'
// import { RegistrationImportService } from '@app/registration-import.module/services';
// import { EventDataImportService } from '@app/event-data-import.module/services';
// import { UploadService } from '@app/shared.module/services';
// import { ImportService } from '@app/import.module/services';


@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent implements OnInit {

  @Input() selectedData: IUploadFile;
  @Input() moduleName: string;
  constructor(public activeModal: NgbActiveModal, private uploadService: UploadService, private toastr: ToastrService, private modalService: NgbModal) { }
  // private uploadService: UploadService,
  ngOnInit() {
  }

  uploadFile() {
    let formData: FormData = new FormData();
    formData.append('file', this.selectedData.FileData as File, this.selectedData.FileData.name);
    formData.append('eventId', this.selectedData.TemplateEventId.toString());
    formData.append('orgCode', this.selectedData.OrganizationCode);
    formData.append('emailId', this.selectedData.NotificationEmail);
    formData.append('moduleName', this.moduleName);

    this.uploadService.uploadFile(formData, this.moduleName).subscribe(resp => {
      this.activeModal.close();
      this.showSuccessMessage('File uploaded successfully');
    }, err => {
      this.activeModal.close();
      this.showErrorMessage(err.error.message);
    });

    // if (this.moduleName == "course") {
    //   this.importService.uploadFile(formData).subscribe(resp => {
    //     this.activeModal.close();
    //     this.showSuccessMessage('File uploaded successfully');
    //   }, err => {
    //     this.activeModal.close();
    //     this.showErrorMessage(err.error.message);
    //   });
    // }
    // if (this.moduleName == "registration") {
    //   this.registrationImportService.uploadFile(formData).subscribe(resp => {
    //     this.activeModal.close();
    //     this.showSuccessMessage('File uploaded successfully');
    //   }, err => {
    //     this.activeModal.close();
    //     this.showErrorMessage(err.error.message);
    //   });
    // }

    // if (this.moduleName == "eventData") {
    //   this.eventDataImportService.uploadFile(formData).subscribe(resp => {
    //     this.activeModal.close();
    //     this.showSuccessMessage('File uploaded successfully');
    //   }, err => {
    //     this.activeModal.close();
    //     this.showErrorMessage(err.error.message);
    //   });
    // }

    this.showThankYou();
  }

  showErrorMessage(message: string) {
    this.toastr.error(message, 'Error', {
      timeOut: 5000
    });
  }

  showSuccessMessage(message: string) {
    this.toastr.success(message, 'Success', {
      timeOut: 5000
    });
  }


  showThankYou() {
    const modalRef = this.modalService.open(ThankYouComponent, { size: 'lg', windowClass: 'custom-addClass-modal', backdropClass: 'light-white-backdrop' });
  }

}
